import { Achievements } from '@components/_ui/Achievements'
import { MotionWrapper } from '@components/_ui/MotionWrapper'
import { getCleaningType } from '@lib/getCleaningType'
import { AnimatePresence } from 'motion/react'
import { useWatch } from 'react-hook-form'

import s from './Header.module.scss'
import type { HeaderProps } from './Header.props'

export function Header(props: HeaderProps) {
  const сleaningType = useWatch({ name: 'requested_cleaning_type' })
  const lastTimeCleaned = useWatch({ name: 'last_time_cleaned' })
  const homeState = useWatch({ name: 'home_state' })

  const basicDeep = getCleaningType({ homeState, lastTimeCleaned, сleaningType })
  let data = null

  if (basicDeep === 'basic') {
    data = props.data?.basic_deep_cleaning_1
  } else if (basicDeep === 'deep') {
    data = props.data?.basic_deep_cleaning_2
  } else {
    data = props.data?.[сleaningType]
  }

  return (
    <AnimatePresence initial={false}>
      <MotionWrapper
        key="header"
        withIndent={false}
      >
        <h1
          className={s.title}
          dangerouslySetInnerHTML={{ __html: data.title }}
        />

        {data?.subtitle && <p className={s.subtitle}>{data.subtitle}</p>}

        <Achievements
          achievements={data?.achievements}
          reversed
          itemClassName={s.item}
          iconWrapperClassName={s.iconWrapper}
        />
      </MotionWrapper>
    </AnimatePresence>
  )
}
